import {Pipe, PipeTransform} from '@angular/core';
import * as _ from 'lodash';
import {DiscardableAlertMessage} from '../models/discardable-alert-message';

@Pipe({ name: 'notDiscarded' })
export class NotDiscardedPipe implements PipeTransform {
  transform(value: DiscardableAlertMessage[]): DiscardableAlertMessage[] { return _.filter(value, msg => !msg.discarded); }
}
